module.exports = __webpack_public_path__ + "assets/img/Singapore University of Social Sciences.572585c0.jpg";